module.exports = __webpack_public_path__ + "static/bsas017-4f82c03e8a458926dbeb27b6cf1fcc43.jpg";